// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".public-key-identification-authentication .common-bg-plate[data-v-06a7701a]{min-height:var(--base-main-router-body-avaliable-height)}", ""]);
// Exports
module.exports = exports;
